import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';

class PrepareBookParams {
  constructor(props) {
    this.props = props;
    this.saveCard = false;
    this.cardId = null;
    this.sendInvoice = false;
    this.paymentId = null;
    this.paymentMethodId = null;
    this.paymentIntentId = null;
    this.paymentDescription = null;
  }

  isSameAsDeparture() {
    return !this.props.differentReturnAddress;
  }

  getDepartureAddress() {
    return this.getAddress(this.props.departureAddress);
  }

  getReturnAddress() {
    if (this.isSameAsDeparture()) {
      return this.getDepartureAddress();
    } else {
      return this.getAddress(this.props.returnAddress);
    }
  }

  //return only google address
  getAddress(addressObject) {
    if (this.isEmptyAddress(addressObject)) {
      return null;
    }

    if (addressObject.selectedObject.g) {
      //is google address
      return addressObject.selectedObject.label;
    } else {
      //is bus stop
      return null;
    }
  }

  getDepartureBusSop() {
    return this.getBusStop(this.props.departureAddress);
  }

  getReturnBusStop() {
    if (this.isSameAsDeparture()) {
      return this.getDepartureBusSop();
    } else {
      return this.getBusStop(this.props.returnAddress);
    }
  }

  //return only google address
  getBusStop(addressObject) {
    if (this.isEmptyAddress(addressObject)) {
      return null;
    }

    if (addressObject.selectedObject.g) {
      //is google address
      return null;
    } else {
      //is bus stop
      return addressObject.selectedObject.value;
    }
  }

  getDeparturePostcode() {
    return this.getPostcode(this.props.departureAddress);
  }

  getReturnPostcode() {
    if (this.isSameAsDeparture()) {
      return this.getDeparturePostcode();
    } else {
      return this.getPostcode(this.props.returnAddress);
    }
  }

  //return only google address
  getPostcode(addressObject) {
    if (this.isEmptyAddress(addressObject)) {
      return null;
    }
    return addressObject.postcode;
  }

  isEmptyAddress(addressObject) {
    return addressObject === null || addressObject.selectedObject === null;
  }

  getDepartureFlight() {
    var df = this.props.departureFlight;
    if (df) {
      return df.id;
    }
    return null;
  }

  getReturnFlight() {
    var rf = this.props.returnFlight;
    if (rf) {
      return rf.id;
    }
    return null;
  }

  setSaveCard(saveCard) {
    this.saveCard = saveCard;
  }

  setPaymentId(value) {
    this.paymentId = value;
  }

  setPaymentMethodId(value) {
    this.paymentMethodId = value;
  }

  setPaymentIntentId(value) {
    this.paymentIntentId = value;
  }

  setSelectedCardId(cardId) {
    this.cardId = cardId;
  }

  setPaymentDescription(value) {
    this.paymentDescription = value;
  }

  isSelectedCard() {
    return !isEmpty(this.cardId);
  }

  getReturnLat() {
    if (this.isSameAsDeparture()) {
      return this.props.departureAddress.lat;
    } else {
      return this.props.returnAddress.lat;
    }
  }

  getReturnLng() {
    if (this.isSameAsDeparture()) {
      return this.props.departureAddress.lng;
    } else {
      return this.props.returnAddress.lng;
    }
  }

  getKidsSafety() {
    //names must be the same as constants in Seat model
    var ks = this.props.kidsSafety;
    return {
      'no_need_car_seat': ks.noNeedCarSeat,
      'cradle': ks.cradle,
      'seat_with_seat_belts': ks.seatWithSeatBelts,
      'seat_without_seat_belts': ks.seatWithoutSeatBelts,
      'car_seat_pad': ks.carSeatPad
    }
  }

  params() {
    const p = this.props;
    return {
      data: {
        'departureFlight': this.getDepartureFlight(),
        'returnFlight': this.getReturnFlight(),
        'child': p.childrenNumber,
        'adult': p.adultsNumber,
        'senior': p.seniorsNumber,
        'city': p.city,
        'student': p.studentsNumber,
        'teenager': p.teenagersNumber,
        'departureAddress': this.getDepartureAddress(),
        'returneAddress': this.getReturnAddress(),
        'departureBusStop': this.getDepartureBusSop(),
        'returnBusStop': this.getReturnBusStop(),
        'departurePostcode': this.getDeparturePostcode(),
        'returnPostcode': this.getReturnPostcode(),
        'departureLat': p.departureAddress.lat,
        'departureLng': p.departureAddress.lng,
        'returnLat': this.getReturnLat(),
        'returnLng': this.getReturnLng(),
        'departurePrice': p.departurePrice,
        'returnPrice': p.returnPrice,
        'name': p.userData.name,
        'phoneCountry': p.userData.phoneCountry ? p.userData.phoneCountry.label : null,
        'phone': p.userData.phone,
        'email': p.userData.email,
        'lang': p.locale,
        'kidsSafety': this.getKidsSafety()
      }
    }
  }

  paramsWithPayment() {
    var params = this.params();
    if (this.isSelectedCard()) {
      params = merge(
        params,
        { data: { selectedCardId: this.cardId } }
      );
    } else {
      params = merge(
        params,
        { data: { saveCard: this.saveCard } }
      );
    }
    if (this.sendInvoice) {
      params = merge(
        params,
        { data: { invoice: true, invoiceData: this.props.invoiceData } }
      );
    }
    params = merge(
      params,
      {
        data: {
          paymentId: this.paymentId,
          paymentMethodId: this.paymentMethodId,
          paymentIntentId: this.paymentIntentId,
          paymentDescription: this.paymentDescription
        }
      }
    );
    return params;
  }

  setSendInvoiceData(value) {
    this.sendInvoice = value;
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.errors.card.' + key);
  }

  isCityFieldValid() {
    const { departureFlight, returnFlight, city } = this.props;
    if (departureFlight == null) {
      return false;
    }
    if (departureFlight && departureFlight.is_arrival) {
      return !isEmpty(city);
    } else if (returnFlight && returnFlight.is_arrival) {
      return !isEmpty(city);
    }
    return true;
  }

  canDoRequest() {
    var params = this.params();
    var data = params["data"];
    var passengerCond = data.child > 0
      || data.adult > 0
      || data.senior > 0
      || data.student > 0
      || data.teenager > 0;
    return data.departureFlight &&
      passengerCond &&
      data.departurePrice &&
      (data.departurePostcode || data.departureBusStop) &&
      data.phoneCountry;
  }
}

export default PrepareBookParams;
